import { useNavigate } from "react-router-dom";
import DashboardSectionCard from "./DashboardSectionCard";
import EmptyState from "./EmptyState";

export default function RecentSearches({ searches = [], loading }) {
  const navigate = useNavigate();

  return (
    <DashboardSectionCard title="Recent Searches" subtitle="Jump back in" icon="fa-clock-rotate-left" colorKey="green">
      {loading ? (
        [...Array(3)].map((_, i) => (
          <div key={i} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 0", borderBottom:"1px solid var(--fc-border-light)" }}>
            <div style={{ width:36, height:36, borderRadius:8, background:"var(--fc-border-light)", flexShrink:0 }} />
            <div style={{ flex:1 }}>
              <div style={{ height:11, background:"var(--fc-border-light)", borderRadius:4, width:"50%", marginBottom:5 }} />
              <div style={{ height:9, background:"var(--fc-bg-light)", borderRadius:4, width:"30%" }} />
            </div>
            <div style={{ width:52, height:24, background:"var(--fc-border-light)", borderRadius:6 }} />
          </div>
        ))
      ) : !searches.length ? (
        <EmptyState icon="fa-magnifying-glass" text="No recent searches" sub="Your search history will appear here" actionLabel="Start searching" actionTo="/search" />
      ) : (
        <div className="fc-scroll-container" style={{ overflowY:"auto", overflowX:"hidden", maxHeight:280, scrollbarWidth:"none" }}>
          {searches.slice(0, 5).map((s, i) => {
            const text   = s.keyword || s.search_text || s.text || (typeof s === "string" ? s : "");
            const isLast = i === Math.min(searches.length, 5) - 1;
            return (
              <div key={i}
                style={{ display:"flex", alignItems:"center", gap:10, padding:"9px 0", borderBottom:isLast?"none":"1px solid var(--fc-border-light)", cursor:"pointer" }}
                onClick={() => navigate(`/search?keyword=${encodeURIComponent(text)}`)}>

                {/* Icon */}
                <div style={{ width:36, height:36, borderRadius:8, background:"var(--fc-border-light)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                  <i className="fa-solid fa-magnifying-glass" style={{ fontSize:13, color:"var(--fc-text-subtle)" }} />
                </div>

                {/* Text */}
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ fontSize:13, fontWeight:600, color:"var(--fc-text-primary)", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{text}</div>
                  <div style={{ fontSize:11, color:"var(--fc-text-subtle)", marginTop:1 }}>Search again</div>
                </div>

                {/* Arrow */}
                <i className="fa-solid fa-arrow-right" style={{ fontSize:11, color:"var(--fc-text-hint)", flexShrink:0 }} />
              </div>
            );
          })}
        </div>
      )}
    </DashboardSectionCard>
  );
}
